<template>
  <div class="">
    <!-- <div v-html="data" class="wrap" v-if="data"></div> -->
    <div v-if="data">
        <div v-html="detail.text"></div>
        <img :src="$typeImage(detail.image,'normal')">
    </div>
    <p v-else>
      <img src="@/assets/image/暂无数据.png" class="m-auto mt-50 mb-50" />
    </p>
  </div>
</template>
<script>
import { reactive } from "@vue/composition-api"
export default {
  props: {
    data: String,
  },
  setup(props, ctx) {
    const detail = reactive({
      text: "",
      image: "",
    })
    let text = props.data?.match(/([\s\S]*)!\[/)
    if (text) {
      detail.text = text[1]
    }
    let reg1 = /(https?:[^:<>"]*\/)([^:<>"]*)(\.((png!thumbnail)|(png)|(jpg)|(webp)|(jepg)))/
    let imgs = props.data?.match(reg1)
    if (imgs) {
      detail.image = imgs[0]
    }
    return {detail};
  },
};
</script>
<style lang="scss" scoped>
// .wrap {
//   ::v-deep img {
//     margin: auto;
//   }
// }
</style>
